module.exports = __webpack_public_path__ + "img/benjamin-lundy.1cf62c38.png";